import { render, staticRenderFns } from "./KisPersonList.vue?vue&type=template&id=e9cf966e"
import script from "./KisPersonList.js?vue&type=script&lang=js&external"
export * from "./KisPersonList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports